import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-card',
  templateUrl: './support-card.component.html',

})
export class SupportCardComponent implements OnInit {
  @Input()
  get statSubtitle(): string {
    return this._statSubtitle;
  }
  set statSubtitle(statSubtitle: string) {
    this._statSubtitle = statSubtitle === undefined ? "" : statSubtitle;
  }
  private _statSubtitle = "";

  @Input()
  get statTitle(): string {
    return this._statTitle;
  }
  @Input()
  get buttontitle(): string {
    return this._buttontitle;
  }
  set statTitle(statTitle: string) {
    this._statTitle = statTitle === undefined ? "" : statTitle;
  }
  private _statTitle = "";

  // The value must match one of up or down
  @Input()
  get description(): string {
    return this._description;
  }

  set description(description: string) {
    this._description = description === undefined ? "7" : description;
  }

  set buttontitle(buttontitle: string) {
    this._buttontitle = buttontitle === undefined ? "7" : buttontitle;
  }
  private _description = "";
  private _buttontitle = "";



  constructor() { }

  ngOnInit(): void {

  }

  goToUrl(): void {
    if (this.buttontitle === 'Show Details') {
      window.open('https://www.quickheal.co.in/support', "_blank", "noopener")
    } else if (this.buttontitle === 'Raise A Ticket') {
      window.open('mailto:support@quickheal.com', "_blank", "noopener")
    } else if (this.buttontitle === 'Chat Support') {
      window.open('https://www.quickheal.co.in/report-an-issue', "_blank", "noopener")
    }
  }
}

